import * as React from 'react';

import { cn } from 'lib/utils';

import type { SkeletonProps } from './types';

/**
 * Base skeleton component with optional shimmer effect
 * Uses Tailwind's animate-pulse by default, can add shimmer overlay
 */
const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, shimmer = false, ...props }, ref) => {
    if (shimmer) {
      return (
        <div ref={ref} className={cn('relative overflow-hidden', className)} {...props}>
          <div className="absolute inset-0 animate-pulse rounded-md bg-primary/10" />
          <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent" />
        </div>
      );
    }

    return (
      <div
        ref={ref}
        className={cn('animate-pulse rounded-md bg-primary/10', className)}
        {...props}
      />
    );
  }
);

Skeleton.displayName = 'Skeleton';

export { Skeleton };
